module.exports = __webpack_public_path__ + "img/KW_gue.0bcd3477.png";